import { jsx, jsxs } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { styled } from "@mui/material";
import { AcceptedPaymentContainer } from "./styles/container.es.js";
import { Primary } from "../../foundations/palette.es.js";
import { BorderRadius } from "../../foundations/border-radius.es.js";
import { InnerLabel } from "./components/inner-label.es.js";
import { Visa } from "./components/visa.es.js";
import { Amex } from "./components/amex.es.js";
import { MasterCard } from "./components/master-card.es.js";
import { Maestro } from "./components/maestro.es.js";
import { Paypal } from "./components/paypal.es.js";
import { ApplePay } from "./components/apple-pay.es.js";
import { Bancomat } from "./components/bancomat.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import { Direction } from "../../foundations/direction.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
const CommonBorder = `1px solid ${Primary.main}`;
const BoxWrapper = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.row,
  alignItems: Alignment.center,
  justifyContent: Alignment.spaceBetween,
  padding: `0 ${Spacing["750"]} ${Spacing["1000"]}`,
  borderRadius: `0 0 ${BorderRadius.brand} ${BorderRadius.brand}`,
  border: CommonBorder,
  borderTop: "0",
  width: "auto"
});
const LeftRadiusStyle = styled("div")({
  borderRadius: `${BorderRadius.brand} 0 0 0`,
  borderTop: CommonBorder,
  borderLeft: CommonBorder
});
const RightRadiusStyle = styled("div")({
  borderRadius: `0 ${BorderRadius.brand} 0 0`,
  borderTop: CommonBorder,
  borderRight: CommonBorder
});
const FlexSpaceBetween = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.row,
  justifyContent: "space-between"
});
const FlexRow = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.row
});
const fullWidth = {
  width: "100%"
};
function AcceptedPayment({
  label,
  labelIcon,
  id
}) {
  const largeFontSize = "large";
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(AcceptedPaymentContainer, { className: "accepted-payment", "data-testid": id ?? "id", children: [
    /* @__PURE__ */ jsxs(FlexSpaceBetween, { children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { style: fullWidth, children: " " }),
        /* @__PURE__ */ jsx(LeftRadiusStyle, { children: " " })
      ] }),
      /* @__PURE__ */ jsxs(FlexRow, { style: fullWidth, children: [
        /* @__PURE__ */ jsx("div", { style: {
          display: Displaying.flex,
          alignItems: Alignment.center
        }, children: /* @__PURE__ */ jsx(InnerLabel, { className: "inner-label", label, icon: labelIcon }) }),
        /* @__PURE__ */ jsx("div", { style: fullWidth, children: /* @__PURE__ */ jsx("div", { style: {
          borderBottom: CommonBorder
        }, children: " " }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { style: fullWidth, children: " " }),
        /* @__PURE__ */ jsx(RightRadiusStyle, { children: " " })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(BoxWrapper, { children: [
      /* @__PURE__ */ jsx(Visa, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(Amex, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(MasterCard, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(Maestro, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(Paypal, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(ApplePay, { fontSize: largeFontSize }),
      /* @__PURE__ */ jsx(Bancomat, { fontSize: largeFontSize })
    ] })
  ] }) });
}
export {
  AcceptedPayment
};
//# sourceMappingURL=accepted-payment.es.js.map
